import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type {
  ValidationDataResult,
  ValidationDataState,
  ValidationRuleName,
} from './validationTypes';

const initialState: ValidationDataState = {};

export type ValidationPayload<T extends ValidationRuleName> = {
  href: string;
  validationRuleName: T;
  data: ValidationDataResult<T>;
  validityHash: string;
};

const validationDataSlice = createSlice({
  name: 'validationData',
  initialState,
  reducers: {
    loadAllValidation: () => {
      return {};
    },
    loadValidationDataForBatch(
      state,
      action: PayloadAction<{
        items: { href: string; validationRuleName: ValidationRuleName; validityHash: string }[];
      }>,
    ) {
      const { items } = action.payload;

      items.forEach(({ href, validationRuleName, validityHash }) => {
        if (!state[href]) {
          state[href] = {};
        }
        if (!state[href][validationRuleName]) {
          state[href][validationRuleName] = {
            isLoading: true,
            data: [],
            validityHash,
          };
        }
      });
    },
    setValidationDataFromBatch: <T extends ValidationRuleName>(
      state,
      action: PayloadAction<ValidationPayload<T>[]>,
    ) => {
      const validationBatchResults = action.payload;
      validationBatchResults.forEach(({ href, validationRuleName, data, validityHash }) => {
        state[href][validationRuleName] = {
          isLoading: false,
          data,
          validityHash,
        };
      });
    },
  },
});

export const { loadAllValidation, loadValidationDataForBatch, setValidationDataFromBatch } =
  validationDataSlice.actions;

export default validationDataSlice;
